import { createSelector } from 'reselect';

// Selectors to extract data from the Redux store
const selectAuthenticated = (state) => state.session.authenticated;

const selectSessionItems = (state) => state.session.items;

const selectLastFreeFlight = (state) => state.session.lastFreeFlight;

const selectSelectedGroupId = (state) => state.groups.selectedId;

const selectGroupsItems = (state) => state.groups.items;

const selectAerosItems = (state) => state.aeros.items;

const selectAerosRunways = (state) => state.aeros.runways;

const selectAerosVisited = (state) => state.aeros.visited;

const selectAerosShowAll = (state) => state.aeros.showAll;

const selectAbonnement = (state) => state.session.abonnement;

const selectPointItems = (state) => state.point.items;

const selectUsersItems = (state) => state.users.items;

const selectSummaryPilotItems = (state) => state.summaryPilot.items;

const selectSummaryPilotResult = (state) => state.summaryPilot.result;

const selectSummaryItems = (state) => state.summary.items;

const selectSummaryPeriodItems = (state) => state.summary.period;

const selectSummaryFromItems = (state) => state.summary.from;

const selectSummaryToItems = (state) => state.summary.to;

const selectDevicesItems = (state) => state.devices.items;

const selectDevicesId = (state) => state.devices.selectedId;

const selectReportTripsItems = (state) => state.reportTrips.items;

const selectPositionsItems = (state) => state.positions.items;

const selectGroupsTokenItems = (state) => state.groups.token;

const selectGroupsClubLatLongItem = (state) => state.groups.clubLatLong;

const selectGeofencesItems = (state) => state.geofences.items;

// Create memoized selectors using createSelector
export const selectAuthenticatedUser = createSelector(
  [selectAuthenticated],
  (authenticated) => authenticated
);

export const selectSession = createSelector([selectSessionItems], (items) => items);

export const selectLastFreeFlightUser = createSelector(
  [selectLastFreeFlight],
  (lastFreeFlight) => lastFreeFlight
);

export const selectGroupSelectedId = createSelector(
  [selectSelectedGroupId],
  (selectedId) => selectedId
);

// Create memoized selectors using createSelector
export const selectGroupsArray = createSelector([selectGroupsItems], (groupsItems) =>
  Object.values(groupsItems)
);

export const selectAerosArray = createSelector([selectAerosItems], (aerosItems) =>
  Object.values(aerosItems)
);

export const selectAerosRunwaysArray = createSelector([selectAerosRunways], (aerosRunways) =>
  Object.values(aerosRunways)
);

export const selectAerosVisitedArray = createSelector([selectAerosVisited], (aerosVisited) =>
  Object.values(aerosVisited)
);

export const selectShowAllAeros = createSelector(
  [selectAerosShowAll],
  (aerosShowAll) => aerosShowAll
);

export const selectAbonnementData = createSelector([selectAbonnement], (abonnement) => abonnement);

export const selectPointItemsData = createSelector([selectPointItems], (pointItems) => pointItems);

export const selectUsersArray = createSelector([selectUsersItems], (usersItems) =>
  Object.values(usersItems)
);

export const selectSummaryPilotArray = createSelector(
  [selectSummaryPilotItems],
  (summaryPilotItems) => Object.values(summaryPilotItems)
);

export const selectSummaryResultArray = createSelector(
  [selectSummaryPilotResult],
  (summaryPilotResult) => Object.values(summaryPilotResult)
);

export const selectSummaryArray = createSelector([selectSummaryItems], (summaryItems) =>
  Object.values(summaryItems)
);

export const selectSummaryPeriod = createSelector([selectSummaryPeriodItems], (items) => items);

export const selectSummaryFrom = createSelector([selectSummaryFromItems], (items) => items);

export const selectSummaryTo = createSelector([selectSummaryToItems], (items) => items);

export const selectDevicesArray = createSelector([selectDevicesItems], (devicesItems) =>
  Object.values(devicesItems)
);

export const selectDevicesSelectId = createSelector([selectDevicesId], (deviceId) => deviceId);

export const selectReportTripsArray = createSelector([selectReportTripsItems], (reportTripsItems) =>
  Object.values(reportTripsItems)
);

export const selectPositionsArray = createSelector([selectPositionsItems], (positionsItems) =>
  Object.values(positionsItems)
);

export const selectGroupsTokenArray = createSelector([selectGroupsTokenItems], (groupsTokenItems) =>
  Object.values(groupsTokenItems)
);

export const selectGroupsClubLatLong = createSelector(
  [selectGroupsClubLatLongItem],
  (clubLatLong) => clubLatLong
);

export const selectGeofencesArray = createSelector([selectGeofencesItems], (geofencesItems) =>
  Object.values(geofencesItems)
);
